/**
 * Interrupteur Gively (28/09/2026) — UN composant pour tous les réglages
 * oui/non de l'espace association. Demande de Lucas : « le plus simple
 * possible visuellement (bouton cochable décochable) ».
 *
 * Repris du Toggle de PreferencesEmailPage (role="switch", zone tactile
 * 48×28). `onChange(next)` reçoit la NOUVELLE valeur, comme un
 * `e.target.checked` : les gardes existantes (confirmations) se branchent
 * sans être réécrites.
 */
export default function ToggleSwitch({
  checked,
  onChange,
  disabled = false,
  label,
  couleur = "bleu",
  className = "",
  ...rest
}) {
  const fond = checked ? (couleur === "vert" ? "bg-[#16c08c]" : "bg-[#1DA1F2]") : "bg-slate-300";
  return (
    <button
      type="button"
      role="switch"
      aria-checked={!!checked}
      aria-label={label}
      disabled={disabled}
      onClick={() => { if (!disabled && onChange) onChange(!checked); }}
      className={`relative inline-flex w-12 h-7 rounded-full transition-colors flex-shrink-0 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1DA1F2] focus-visible:ring-offset-2 ${fond} ${disabled ? "opacity-50 cursor-not-allowed" : "cursor-pointer"} ${className}`}
      {...rest}
    >
      <span
        aria-hidden="true"
        className={`absolute top-0.5 left-0.5 w-6 h-6 bg-white rounded-full shadow transition-transform ${checked ? "translate-x-5" : ""}`}
      />
    </button>
  );
}
